import { render } from "./LabelMarkersConfig.vue?vue&type=template&id=770c7519&scoped=true"
import script from "./LabelMarkersConfig.vue?vue&type=script&lang=js"
export * from "./LabelMarkersConfig.vue?vue&type=script&lang=js"

import "./LabelMarkersConfig.vue?vue&type=style&index=0&id=770c7519&scoped=true&lang=css"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770c7519"]])

export default __exports__